<i
  *ngIf="!data?.partner"
  class="bi bi-link-45deg link-icon"
  (click)="handleLinkClick($event)"
  title="Link Partner">
</i>

<div *ngIf="data?.partner" class="qr-code-container" (click)="openQrCodeModal($event)">
  
  <app-shimmer-loader
    *ngIf="isLoading"
    height="25px"
    width="25px"
    class="position-absolute">
  </app-shimmer-loader>

  <img
    [src]="getQrCodeUrl()"
    alt="Partner QR Code"
    class="qr-code-image"
    title="Click to view full QR Code"
    (load)="onQrLoaded()"
    [class.d-none]="isLoading"
  />
</div>
